import { __read, __spread } from "tslib";
import { NewInstanceResolver } from '../resolvers/NewInstanceResolver';
import { decorateParameterOrProperty } from './decorateParameterOrProperty';
export function NewInstance(targetOrAsKey) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var deco = function (k) {
        var dynamicDeps = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            dynamicDeps[_i - 1] = arguments[_i];
        }
        var resolver = function (x) {
            var value = NewInstanceResolver.of.apply(NewInstanceResolver, __spread([x], dynamicDeps));
            if (!!k) {
                value.as(k);
            }
            return value;
        };
        return decorateParameterOrProperty(resolver, 'newInstance');
    };
    if (args.length > 0 && typeof args[0] === 'string') {
        // tslint:disable-next-line:no-non-null-assertion
        return deco()(targetOrAsKey, args[0], args[1]);
    }
    return deco.apply(void 0, __spread([targetOrAsKey], args));
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmV3SW5zdGFuY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZXdJbnN0YW5jZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxFQUFFLG1CQUFtQixFQUFFLE1BQU0sa0NBQWtDLENBQUM7QUFFdkUsT0FBTyxFQUFFLDJCQUEyQixFQUFFLE1BQU0sK0JBQStCLENBQUM7QUFZNUUsTUFBTSxVQUFVLFdBQVcsQ0FBQyxhQUFpQztJQUFFLGNBQWM7U0FBZCxVQUFjLEVBQWQscUJBQWMsRUFBZCxJQUFjO1FBQWQsNkJBQWM7O0lBQ3pFLElBQU0sSUFBSSxHQUFHLFVBQUMsQ0FBWTtRQUFFLHFCQUFxQjthQUFyQixVQUFxQixFQUFyQixxQkFBcUIsRUFBckIsSUFBcUI7WUFBckIsb0NBQXFCOztRQUM3QyxJQUFNLFFBQVEsR0FBRyxVQUFDLENBQU07WUFDcEIsSUFBTSxLQUFLLEdBQUcsbUJBQW1CLENBQUMsRUFBRSxPQUF0QixtQkFBbUIsWUFBSSxDQUFDLEdBQUssV0FBVyxFQUFDLENBQUM7WUFFeEQsSUFBSSxDQUFDLENBQUMsQ0FBQyxFQUFFO2dCQUNMLEtBQUssQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUM7YUFDZjtZQUVELE9BQU8sS0FBSyxDQUFDO1FBQ2pCLENBQUMsQ0FBQztRQUVGLE9BQU8sMkJBQTJCLENBQUMsUUFBUSxFQUFFLGFBQWEsQ0FBQyxDQUFDO0lBQ2hFLENBQUMsQ0FBQztJQUVGLElBQUksSUFBSSxDQUFDLE1BQU0sR0FBRyxDQUFDLElBQUksT0FBTyxJQUFJLENBQUMsQ0FBQyxDQUFDLEtBQUssUUFBUSxFQUFFO1FBQ2hELGlEQUFpRDtRQUNqRCxPQUFPLElBQUksRUFBRSxDQUFDLGFBQWMsRUFBRSxJQUFJLENBQUMsQ0FBQyxDQUFDLEVBQUUsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7S0FDbkQ7SUFFRCxPQUFPLElBQUkseUJBQUMsYUFBb0IsR0FBSyxJQUFJLEdBQUU7QUFDL0MsQ0FBQyJ9